import {
	gridGutter,
	gridGutterHalf,
	gridGutter1q4
} from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/layout";
import {
	grayBorder,
	grayFont
} from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/colors";

import { offersRedColor, offersWhiteColor } from '../../../../shared/variables';

export const defaultStyle = (mobile = false) => `
	padding: ${mobile ? 0 : gridGutter * 1.5}px 0;
	border-top: ${mobile ? 0 : 1}px solid ${grayBorder};

	.gain {
		color: ${mobile ? "#2f3e5e" : grayFont};
		font-weight: ${mobile ? 600 : 400};
	}

	.align-center {
		text-align: ${mobile ? "center" : "left"};
		display: ${mobile ? "block" : "initial"};
		padding: ${mobile ? gridGutter1q4 : 0}px ${mobile ? gridGutter : 0}px 0;

		&.p-0 {
			padding: 0;
		}

		&.m-0 {
			margin: 0;
		}
	}

	p.align-center {
		display: block;
	}

	header {
		color: #2f3e5e;
		font-weight: 800;
		text-transform: uppercase;
		padding-bottom: ${gridGutter}px;
		display: ${mobile ? "none" : "block"};

		span {
			border-radius: 4px;
			background-color: ${offersRedColor};
			color: ${offersWhiteColor};
			padding: 3px 8px;
			font-size: 12px;
			font-weight: 600;
			text-transform: none;
			margin-left: 5px;
		}
	}

	footer {
		padding-top: ${mobile ? gridGutterHalf : gridGutter}px;
		p {
			strong {
				color: #2f3e5e;
				span {
					font-size: 24px;  
					font-weight: 800;
				}
			}
			a {
				font-weight: bold;
			}
		}
	}
`;
